import { t } from 'i18next'
import React from 'react'
import CustomImageComponent from './CustomImageComponent';
import { useCountryPrefix } from '../routes/useCountryPrefix';

const DeveloperStartsFrom = (props) => {
    const countryPrefix = useCountryPrefix();

    const { companyName, location, priceStart, priceEnd, developerLogo, phone, whatsApp } = props

    if (!companyName || !developerLogo) return null;
    return (

        <section className="company-info-section">
            <div className="container">
                <div className="company-info-wrapper">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-lg-5">
                            <div className="left-block">
                                <div className="img-block w-25">
                                    {/* <CustomImageComponent src={"/assets/img/company-logo.png"} alt={""} /> */}
                                    <CustomImageComponent src={developerLogo} alt={companyName} className={'w-100'} />
                                </div>
                                <div className="content-block">
                                    <h5>
                                        {companyName}<span>{t("property")}</span>
                                    </h5>
                                    <p>{location ? location.substr(0, 50).trim() : location}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-7">
                            <div className="right-block">
                                {priceStart ? (<div>
                                    <h4>{t("price_start")}</h4>
                                    <p><span style={{ fontSize: '12px' }}>{countryPrefix === 'eg' ? t('egp') : t('aed')} </span>{Intl.NumberFormat('EG', { currency: 'INR' }).format(priceStart)}</p>
                                </div>) : ""}

                                {priceEnd ? (<div>
                                    <h4>{t("price_to")}</h4>
                                    <p><span style={{ fontSize: '12px' }}>{countryPrefix === 'eg' ? t('egp') : t('aed')} </span>{Intl.NumberFormat('EG', { currency: 'INR' }).format(priceEnd)}</p>
                                </div>) : ""}

                                {/* <div>
                                    <h4>Price Starts From</h4>
                                    <p>$43,424,000</p>
                                </div> */}
                                <div>

                                    <a className="call-btn" href={phone ? `tel:${phone}` : "#"}>

                                        <CustomImageComponent src={"/assets/img/icon-call.svg"} alt={"Phone"} /> {t("call_us")}
                                    </a>
                                    <a className="call-btn whatsapp-btn" href={whatsApp ? `https://wa.me/${whatsApp}` : "#"} target="_blank" rel="noopener noreferrer">

                                        <CustomImageComponent src={"/assets/img/icon-whatsapp.svg"} alt={"WhatsApp"} />
                                        {t("whatsapp")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default DeveloperStartsFrom